import { render } from "./StaffDetails.vue?vue&type=template&id=fdfb0bc0&scoped=true"
import script from "./StaffDetails.vue?vue&type=script&lang=js"
export * from "./StaffDetails.vue?vue&type=script&lang=js"

import "./StaffDetails.vue?vue&type=style&index=0&id=fdfb0bc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfb0bc0"]])

export default __exports__